import { Injectable } from '@angular/core';
import { FilterFieldDef, FilterFieldType, FilterFieldValue } from '../../../covance-filter';
import { EQueryUsageReportType } from './e-query-usage-report-type';

export const rangeDateFilter: FilterFieldDef = {
    title: 'Date Range',
    queryParam: 'date',
    isServerSideFilter: true,
    type: FilterFieldType.DateRange,
};


export const siteFilter: FilterFieldDef = {
    title: 'Site',
    queryParam: 'site',
    isServerSideFilter: true,
    type: FilterFieldType.MultiSelect
};

@Injectable()
export class UsageEQueryReportFilterItemsResolver {
    private usageReportTypesDictionary: { [key in EQueryUsageReportType]?: FilterFieldDef[] };

    constructor() {
        this.fillReportTypesDictionary();
    }

    public resolveFilterItems(usageReportType: EQueryUsageReportType): FilterFieldValue[] {
        const filterDefs = this.usageReportTypesDictionary[usageReportType] || [];
        return filterDefs.map(f => ({def: f}));
    }

    private fillReportTypesDictionary() {
        this.usageReportTypesDictionary = {
            'Protocol': [siteFilter, rangeDateFilter],
            'Project': [siteFilter, rangeDateFilter],
            'Sponsor': [rangeDateFilter],
            'Country': [rangeDateFilter]
        };
    }
}
